import { View } from "react-native";
import { useSafeArea } from "src/swsh-native";
import { GatheringHeaderProps } from "../../types";
import GatheringHeaderEndSection from "../GatheringHeaderEndSection";
import GatheringHeaderName from "../GatheringHeaderName";
import GatheringHeaderRowActions from "../GatheringHeaderRowActions";
import GatheringHeaderRegularMiniCards from "./components/GatheringHeaderRegularMiniCards";
import GatheringHeaderRegularThumbnail from "./components/GatheringHeaderRegularThumbnail";

const GatheringHeaderRegular = ({
	wheelData,
	renderWheelItem,
	thumbnailUrl_1x1,
	name,
	renderName,
	renderRowActions,
	renderEndSection,
	wheelDataLoading,
	regularOptions,
	testID,
	renderThumbnailOverlay,
	hideRowActions,
	miniCards,
}: Omit<GatheringHeaderProps<any>, "variant">) => {
	const safeArea = useSafeArea();
	return (
		<View
			testID={testID}
			style={{
				width: "100%",
				alignItems: "center",
				paddingTop: safeArea.top,
			}}
		>
			<GatheringHeaderRegularThumbnail
				wheelData={wheelData}
				renderWheelItem={renderWheelItem}
				wheelDataLoading={wheelDataLoading}
				thumbnailUrl_1x1={thumbnailUrl_1x1}
				regularOptions={regularOptions}
				renderThumbnailOverlay={renderThumbnailOverlay}
			/>
			<GatheringHeaderName name={name} renderName={renderName} />
			{!!miniCards && <GatheringHeaderRegularMiniCards miniCards={miniCards} />}
			{!!renderRowActions && (
				<GatheringHeaderRowActions
					variant="Regular"
					renderRowActions={renderRowActions}
					hideRowActions={hideRowActions}
				/>
			)}
			{!!renderEndSection && (
				<GatheringHeaderEndSection variant="Regular" renderEndSection={renderEndSection} />
			)}
		</View>
	);
};
export default GatheringHeaderRegular;
